/* eslint-disable */

import { arrayBufferToString } from '../utils/helpers';
import { fromAbortSignal } from './adapters';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse, CancelTokenSource } from 'axios';

import {
  ApiBridgeCameraCreate,
  ApiBridgeCreate,
  Location,
  NotificationParams,
  NotificationActorsParams,
  ApiPaginatedCameraResponse,
  ApiPaginatedBridgeResponse,
  ApiCameraMain,
  ApiBridgeMain,
  ApiPaginatedAvailableDeviceResponse,
  ApiPaginatedSwitchResponse,
  ApiPaginatedFeedResponse,
  ApiPtzPosition,
  PaginatedLocationResponse,
  BasicLocationResponse,
  LocationGet,
  Notifications,
  NotificationActors,
  ApiAddSpeaker,
  PaginatedSpeakerResponse,
  ApiSpeakerMain,
  ApiPaginatedLayoutResponse,
  ApiLayoutCreate,
  ApiLayout,
  mediaMainRequest,
  ApiPaginatedMediaResponse,
  GetCamerasParams,
  DeleteCameraId,
  GetSpeakersParams,
  DeleteSpeakerId,
  UpdateLayoutParams,
  DeleteLayoutId,
  GetBridgeId,
  UpdateBridgeParams,
  SwapBridgeParams,
  DeleteBridgeId,
  BridgeId,
  GetFeedsParams,
  GetPTZPositionCameraId,
  MovePTZParams,
  EditLocationParams,
  DeleteLocationId,
  GetLocationId,
  GetFloorId,
  UpdateNotificationParams,
  ApiUpdateBulkCamera,
  BulkUpdateResponses,
  RecordedImageParams,
  RecordedImage,
  RecordedImageError,
  RecordedImageErrorDetails,
  PaginatedFloorsResponse,
  PaginatedFloorplansResponse,
  PaginatedEditionResponse,
  EditionsAccountId,
  EditionId,
  Edition,
  ApiPaginatedUserResponse,
  ApiAccountWithIncludes,
  ApiAccountPatch,
  GetUsersParams,
  AuditLogRequest,
  AuditEvents,
  ApiDevicePositionCamera,
  AnntRequest,
  ApiAccountCapabilities,
  FloorplanResponse,
  FloorResponse,
  TagsList,
  ApiPaginatedMultiCameraResponse,
  GetMultiCamerasParams,
  updateFloorParams,
  ApiUserWithIncludes,
  TagsRequest,
  GetLayoutsParams,
  AvailableLanguageResponse,
  ApiAuthentication,
  AvailableLanguageRequest,
  ApiAuthenticationCode,
  ApiUserSelfUpdate,
  PaginatedEventsResponse,
  PaginatedEventTypesResponse,
  EventsRequestParams,
  EventTypeRequestParams,
  EventFieldValues,
  PaginatedEventFieldValuesResponse,
  ApiUserUpdate,
  CameraAccessResponse,
  CameraAccessRequest,
  ResourceGrants,
  AuditLogAlertConditionRulesRequest,
  PaginatedAuditLogAlertConditionRules,
  AuditLogAlertConditionRule,
  CreateAuditLogAlertConditionRule,
  UpdateAuditLogAlertConditionRule,
  CreateEventAlertConditionRulePayload,
  EventAlertConditionRulesListQueryParams,
  EventAlertConditionRulesListResponse,
  EventAlertConditionRuleResponse,
  EventAlertFieldValuesResponse,
  UpdateEventAlertConditionRule,
  ApiAddUser,
  ApiPaginatedTrustedClientResponse,
  GetTrustedDevicesParams,
  ApiPaginatedAlertResponse,
  GetAlertsParams,
  AddNewLPRVehicleRecordInListRequestPayload,
  AddNewLPRVehicleRecordInListResponse,
  ApiPaginatedRuleResponse,
  CreateLPRAlertConditionRuleRequestPayload,
  CreateLPRAlertConditionRuleResponse,
  CreateLPRVehicleListRequestPayload,
  CreateLPRVehicleListResponse,
  GetRulesParams,
  LPRAcccountAlertsQueryParams,
  LPRAccountAlertsResponse,
  LPRAlertConditionRuleResponse,
  LPRAlertConditionRulesListFieldValuesResponse,
  LPRAlertConditionRulesListQueryParams,
  LPRAlertConditionRulesListResponse,
  LPRAlertResponse,
  LPRAlertsQueryParams,
  LPRAlertsResponse,
  LPREventQueryParams,
  LPREventResponse,
  LPREventsFieldValuesResponse,
  LPREventsQueryParams,
  LPREventsResponse,
  LPREventsSummaryQueryParams,
  LPREventsSummaryResponse,
  LPRVehicleListResponse,
  LPRVehicleListsFieldsResponse,
  LPRVehicleListsFieldValuesResponse,
  LPRVehicleListsQueryParams,
  LPRVehicleListsResponse,
  LPRVehicleRecordInListResponse,
  LPRVehicleRecordsInAllListsQueryParams,
  LPRVehicleRecordsInAllListsResponse,
  LPRVehicleRecordsInListQueryParams,
  LPRVehicleRecordsInListResponse,
  UpdateLPRAlertConditionRuleRequestPayload,
  UpdateLPRVehicleListRequestPayload,
  UpdateLPRVehicleRecordInListRequestPayload,
  GetFilesParams,
  ApiPaginatedFileResponse,
  TimeZonesList,
  TimeZonesRequest,
  ApiPaginatedActionResponse,
  ApiFileWithIncludes,
  UpdateFileParams,
  NewFileParams,
  ApiCreateExportResponse,
  ExportDetails,
  PaginatedJobResponse,
  ApiAlertListFieldResponse,
  GetAlertListFieldParams,
  GetJobsParams,
  ApiAuditLogListFieldResponse,
  CameraSettingsQueryParams,
  CameraSettingsResponse,
  UpdateDownloadParams,
  GetActionsParams,
  ApiActionCreate,
  ApiActionUpdate,
  AlertConditionRulesQueryParams,
  AlertConditionRulesResponse,
  AlertConditionRuleResponse,
  CreateAlertActionRuleRequestPayload,
  CreateAlertActionRuleResponse,
  AlertActionRulesQueryParams,
  AlertActionRulesResponse,
  AlertActionRuleResponse,
  UpdateAlertConditionRuleRequestPayload,
  UpdateAlertActionRuleRequestPayload,
  CreateAlertActionRequestPayload,
  CreateAlertActionResponse,
  AlertActionsQueryParams,
  AlertActionsResponse,
  AlertActionResponse,
  UpdateAlertActionRequestPayload,
  ApiRuleActionsCreate,
  ApiPaginatedRuleActionsResponse,
  ApiAccountPaginatedCredentials,
  GetAccountCameraCredentialsParams,
  AddAccountCameraCredentialsParams,
  GetAccountsParams,
  SpeakerWithIncludes,
  GetActionRulesParams,
  GetMetricsParams,
  MetricQueryResponse,
  CameraTunnelResponse,
  CreateTunnelParam,
  ApiCopyExportBody,
  ApiCopyExportResponse,
  GetLocationParams,
  GetAvailableDevicesParams,
  SwapCameraParams,
  VSObjectClassResponse,
  VSObjectClassAttributesResponse,
  PatchBridgeSettings,
  GetBridgeSettings,
  GetBridgeParams,
  ApiSwitchAdd,
  SwitchPortActionParam,
  ApiSwitchUpdate,
  GetSwitchesParams,
  ApiSwitchWithIncludes,
  ApiBridgeWithIncludes,
  VSMapNLQueryToAttributesRequestPayload,
  VSMapNLQueryToAttributesQueryParams,
  VSMapNLQueryToAttributesResponse,
  VSEventsDeepSearchQueryParams,
  VSEventsDeepSearchRequestPayload,
  VSEventsDeepSearchResponse,
  VSEventQueryParams,
  VSEventResponse,
  VSEventsGroupSearchQueryParams,
  VSEventsGroupSearchRequestPayload,
  VSEventsGroupSearchResponse,
  VSEventsTimeGroupSearchQueryParams,
  VSEventsTimeGroupSearchRequestPayload,
  VSEventsTimeGroupSearchResponse,
  VSEventsListFieldValuesQueryParams,
  VSEventsListFieldValuesRequestPayload,
  VSEventsListFieldValuesResponse,
  VSEventsListObjectValuesQueryParams,
  ApiAuthSettings,
  ApiCameraWithIncludes,
  PatchCameraSettings,
  SpeakerSettingsQueryParams,
  AdvancedSpeakerSettings,
  VSEventsListObjectValuesResponse,
  GetMultiCameraParams,
  ApiMultiCameraWithIncludes,
  ApiPaginatedMultiCameraChannelResponse,
  ApiMultiCameraUpdate,
  MultiCameraSettingsQueryParams,
  MultiCameraSettingsGet,
  UpdateMultiCameraSettings,
  POSEventQueryParams,
  POSEventsResponse,
  POSEventsQueryParams,
  POSEventResponse,
  POSEventFieldValuesResponse,
  POSEventUpdateTransactionFlagPayload,
  ApiDewarpConfigComposite,
  ApiDewarpConfig,
  VSFaceSearchEventQueryParams,
  VSFaceSearchEventResponse,
  ApiAuthSettingsUpdate,
  PaginationQueryParams,
  ApiPaginatedEventSubscriptionsResponse,
  EventSubscriptionCreate,
  EventSubscription,
  Job,
  CreateJobRequestPayload,
  PosOAuthLogin,
  PoSIntegrationParams,
  PoSSummaryParams,
  PoSSummaryResponse,
  PoSIntegrationResponse,
  PoSIntegrationData,
  UpdatePoSIntegrationRequest,
  AvailableRegistersQueryParams,
  AvailablePoSRegistersResponse,
  GetPoSRegistersQueryParams,
  GetPoSRegistersResponse,
  CreatePoSRegister,
  PoSRegisterResponse,
  UpdatePoSRegister,
  PoSOAuthLoginResponse,
  CameraTuningParams,
  PaginatedResponderResponse,
  ResponderCameraBulkCreate,
  BulkResponseCameras,
  ResponderCameraBulkDelete,
  PaginatedCameraResponse,
  ResponderBulkDelete,
  BulkResponseResponders,
  CameraIOSettingsQueryParams,
  PaginatedCameraIOSettingsPortResponse,
  ResponderBulkCreate,
  PortPatch,
  GetEventMetricsParams,
  EventMetricsGetResponse,
  PaginatedRecordedImageFieldValuesResponse,
  RecordedImageFieldValuesParams,
  ApiPaginatedAnalyticsSettingsResponse,
  AnalyticsType,
  AnalyticsSettingsGet,
  AnalyticsSettingsPatchSingle,
  AnalyticsSettingsPatch,
  GetDelegatesParams,
  PaginatedDelegateResponse,
  CreateDelegate,
  CreateDelegateResponse,
  UpdateDelegate,
  Delegates,
  ApiPaginatedDelegateGrantResponse,
  GetDelegatesGrantParams,
  DelegateGrantsBulkCreate,
  DelegateGrantsBulkDelete,
  BulkCreateDelegateGrantResponse,
  BulkDeleteDelegateGrantResponse,
  userRoleSettings,
  DewarpConfigUpdate,
  CameraFieldValues,
  getCamerasFieldParams,
  ResponderPatch,
  ApiUserNotificationSettings,
  MessageContext,
  FilterCreate,
  Filter,
  AuditLogListFilterValueRequest,
  SharesBulkDelete,
  SharesBulkCreate,
  PaginatedShareResourcesResponse,
  ShareUpdate,
  Share,
  ShareCreate,
  PaginatedShareResponse,
  UserPreference,
  ApiPaginatedAuditLogsListFilterValue,
  CameraTunnelParams,
  GetSharesParams,
  CameraSupportRequest,
  ApiUserMain,
  ApiErrorResponse,
  LPRVehicleRecordBulkCreateResponse,
  AccountCapabilityParams,
  FileGrantUpdate,
  FileGrantResponse,
  FileGrant,
  PaginatedFileGrantsResponse,
  ApiPaginatedSwitchResponseV2,
  GetSSOSettingsParams,
} from '../service/api-types';
import { PtzSettings, PtzSettingsQueryParams } from './api-types/ptzSettings';
import {
  ApiGatewayCreate,
  ApiGatewayUpdate,
  ApiGatewayWithIncludes,
  ApiPaginatedGatewayResponse,
  GetGatewaysParams,
} from './api-types/gateways';
import {
  GetAvailableSensorDevicesParams,
  ApiPaginatedAvaibleSensorDeviceResponse,
} from './api-types/avaiableSensorDevices';
import {
  GetSensorDevicesParams,
  ApiPaginatedSensorDeviceResponse,
  ApiSensorDeviceMain,
  ApiSensorDeviceUpdate,
  ApiSensorDeviceCreate,
  ApiSensorDeviceWithIncludes,
} from './api-types/sensorDevices';
import { ApiSensorSummaryResponse, GetSensorSummaryRequestParams } from './api-types/sensorSummary';
import {
  ApiMeasurementFieldValuesWithIncludes,
  ApiMeasurementUpdate,
  ApiMeasurementWithIncludes,
  ApiPaginatedMeasurementsResponse,
  GetMeasurementFieldValuesParams,
  GetMeasurementsParams,
} from './api-types/measurements';
import {
  ApiMeasurementThresholdCreate,
  ApiMeasurementThresholdMain,
  ApiMeasurementThresholdUpdate,
  ApiMeasurementThresholdWithIncludes,
  ApiPaginatedMeasurementThresholdResponse,
  GetMeasurementThresholdsParams,
} from './api-types/measurementThresholds';

import {
  GetSensorTimeSeriesParams,
  ApiPaginatedSensorTimeSeriesResponse,
  ApiSensorTimeSeriesMain,
} from './api-types/sensorTimeSeries';
import {
  CreateReportScheduleRequestPayload,
  PaginatedReportScheduleResourceResponse,
  PaginatedReportResourceResponse,
  ReportScheduleResourceResponse,
  ReportResource,
  ReportsQueryParams,
  ReportSchedulesQueryParams,
} from './api-types/reports';
import {
  ApiBulkCreateRoleAssignment,
  ApiBulkDeleteRoleAssignment,
  ApiBulkDeleteRoleAssignmentResponse,
  ApiBulkRoleAssignmentResponse,
  CreateRolesParams,
  CreateRolesResponse,
  GetRoleAssignmentResponse,
  GetRoleAssignmentsParams,
  GetRoleParams,
  GetRolesParams,
  PaginatedRolesResponse,
  Role,
  UpdateRolePayload,
} from './api-types/roles';
import { ApiPaginatedApplicationLinksResponse, ApplicationLinkParams } from './api-types/applicationLinks';
import { SCIMSettings, SCIMSettingsUpdateParams, SCIMSettingsUpdateResponse } from './api-types/scimSettings';
import {
  ApiIdPGroupAssignmentsBulkCreateRequest,
  ApiIdPGroupAssignmentsBulkDeleteRequest,
  ApiIdPGroupAssignmentsBulkResponse,
  ApiIdPGroupResponse,
  ApiPaginatedIdPGroupAssignmentResponse,
  ApiPaginatedIdPGroupResponse,
  IdPGroupAssignmentsParams,
  IdPGroupParams,
  IdPGroupsParams,
} from './api-types/idp-groups';
import { EevaQueryPayload, EevaQueryResponse } from './api-types/eeva';
import {
  ApiDeviceIo,
  ApiDeviceIoPatch,
  GetDevicePortParams,
  GetDevicePortsParams,
  GetRecordingActionsDevices,
  PaginatedDevicesIOResponse,
  PaginatedPortRecordingActionResponse,
  PortRecordingActionGet,
  PortRecordingActionPatch,
} from './api-types/deviceIO';

type ApiListType = {
  token: string;
  baseURL: string;
  plainAuthToken: string;
};

class ApiList {
  getLanguage() {
    return window.$cookies.get('lang') || 'en-US';
  }

  headers() {
    return {
      Authorization: 'bearer ' + (this as unknown as ApiListType).token,
      'Accept-Language': this.getLanguage(),
    };
  }

  axiosConfig() {
    return {
      baseURL: (this as unknown as ApiListType).baseURL,
      withCredentials: true,
      headers: this.headers(),
    };
  }

  axiosConfigForV1Api() {
    return {
      baseURL: 'https://c000.eagleeyenetworks.com',
      withCredentials: true,
    };
  }

  axiosConfigForSpeaker() {
    // added temporarily, will be removed once ticket EEPD-12605 is resolved.
    return {
      baseURL: (this as unknown as ApiListType).baseURL,
      withCredentials: true,
      headers: {
        Authorization: 'Bearer ' + (this as unknown as ApiListType).token,
      },
    };
  }

  axiosConfigForMultipart() {
    const headers = Object.assign({}, this.headers(), {
      'Content-Type': 'multipart/form-data',
    });
    return {
      baseURL: (this as unknown as ApiListType).baseURL,
      withCredentials: true,
      headers: headers,
    };
  }

  axiosConfigForBlob(): AxiosRequestConfig {
    return {
      baseURL: (this as unknown as ApiListType).baseURL,
      withCredentials: true,
      headers: this.headers(),
      responseType: 'blob',
    };
  }

  axiosConfigForExternal() {
    return {
      baseURL: (this as unknown as ApiListType).baseURL.replace('/api/v3.0', '/external'),
      headers: this.headers(),
    };
  }

  async getMediaCookie() {
    const res = await axios.get('/media/session', this.axiosConfig());
    axios.get(res.data.url, this.axiosConfig());
  }

  async getCameras(params: GetCamerasParams): Promise<ApiPaginatedCameraResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/cameras`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getCamerasOrError(params: GetCamerasParams): Promise<ApiPaginatedCameraResponse> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/cameras`, config);
    return res.data;
  }

  async getCamerasListFieldValues(params: getCamerasFieldParams): Promise<CameraFieldValues | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/cameras:listFieldValues`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getCamera(cameraId: string, params?: GetCamerasParams): Promise<ApiCameraWithIncludes | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/cameras/${cameraId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async swapCamera(params: SwapCameraParams) {
    const { cameraId, guid } = params;
    try {
      const res = await axios.patch(`/cameras/${cameraId}:swap`, { guid }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getMultiCameras(params: GetMultiCamerasParams): Promise<ApiPaginatedMultiCameraResponse | undefined> {
    if (!params.include) {
      params.include = [
        'status',
        'locationSummary',
        'deviceAddress',
        'timeZone',
        'notes',
        'tags',
        'devicePosition',
        'networkInfo',
        'deviceInfo',
        'firmware',
        'visibleByBridges',
      ].toString();
    }

    const config = Object.assign({}, this.axiosConfig(), { params });

    try {
      const res = await axios.get(`/multiCameras`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteCamera(cameraId: DeleteCameraId): Promise<number | undefined> {
    try {
      const res = await axios.delete(`/cameras/${cameraId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteMultiCamera(multiCameraId: string) {
    try {
      const res = await axios.delete(`/multiCameras/${multiCameraId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async addCamera(payload: ApiBridgeCameraCreate) {
    const res = await axios.post(`/cameras`, payload, this.axiosConfig());

    // Returning response since the reason for error is required for showing error message
    // in the case of camera limit exceeding while adding camera to a bridge
    return res;
  }

  async editCamera(payload: any, id: any) {
    const res = await axios.patch(`/cameras/${id}`, payload, this.axiosConfig());
    return res.status;
  }

  async editCameraDevicePosition(payload: ApiDevicePositionCamera, id: string) {
    const res = await axios.patch(`/cameras/${id}/devicePosition`, payload, this.axiosConfig());
    return res.status;
  }

  async bulkUpdateCamera(payload: ApiUpdateBulkCamera): Promise<BulkUpdateResponses | undefined> {
    try {
      const res = await axios.post(`/cameras:bulkUpdate`, payload, this.axiosConfig());
      return res.data.response;
    } catch (error) {
      console.log(error);
    }
  }

  async cameraFocusTuning(params: CameraTuningParams, id: string) {
    try {
      const res = await axios.put(`/cameras/${id}/imageTuning`, { ...params }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.error(error);
    }
  }

  async getSpeakers(params: GetSpeakersParams): Promise<PaginatedSpeakerResponse | SpeakerWithIncludes | undefined> {
    const { speakerId, ...newParams } = params;

    if (!newParams.include) {
      newParams.include = [
        'deviceInfo',
        'devicePosition',
        'networkInfo',
        'notes',
        'settings',
        'status',
        'tags',
        'timeZone',
        'visibleByBridges',
        'effectivePermissions',
        'capabilities',
      ].toString();
    }

    const config = Object.assign({}, this.axiosConfigForSpeaker(), {
      params: newParams,
    });

    try {
      const res = await axios.get(`/speakers${speakerId ? '/' + speakerId : ''}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteSpeaker(speakerId: DeleteSpeakerId): Promise<number | undefined> {
    try {
      const res = await axios.delete(`/speakers/${speakerId}`, this.axiosConfigForSpeaker());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async addSpeaker(payload: ApiAddSpeaker): Promise<ApiSpeakerMain | undefined> {
    try {
      const res = await axios.post(`/speakers`, payload, this.axiosConfigForSpeaker());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async editSpeaker(payload: any, id: any) {
    try {
      const res = await axios.patch(`/speakers/${id}`, payload, this.axiosConfigForSpeaker());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getLayouts(payload: GetLayoutsParams): Promise<ApiPaginatedLayoutResponse | undefined> {
    try {
      const { layoutId, ...params } = payload;
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/layouts${layoutId ? '/' + layoutId : ''}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateLayout(params: UpdateLayoutParams) {
    const { layoutId, payload } = params;
    try {
      const res = await axios.patch(`/layouts/${layoutId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteLayouts(layoutId: DeleteLayoutId): Promise<number | undefined> {
    try {
      const response = await axios.delete(`/layouts/${layoutId}`, this.axiosConfig());
      return response.status;
    } catch (error) {
      console.log(error);
    }
  }

  async createLayout(newLayout: ApiLayoutCreate): Promise<ApiLayout | undefined> {
    try {
      const res = await axios.post(`/layouts`, newLayout, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getBridges(params: GetBridgeParams): Promise<ApiPaginatedBridgeResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/bridges`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getBridge(bridgeId: GetBridgeId, params?: GetBridgeParams): Promise<ApiBridgeWithIncludes | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/bridges/${bridgeId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getBridgeSettings(bridgeId: GetBridgeId): Promise<GetBridgeSettings | undefined> {
    try {
      const res = await axios.get(`/bridges/${bridgeId}/settings`, this.axiosConfig());
      return res.data.data;
    } catch (error) {
      console.log(error);
    }
  }

  async patchBridgeSettings(bridgeId: GetBridgeId, payload: PatchBridgeSettings) {
    try {
      const res = await axios.patch(`/bridges/${bridgeId}/settings`, { data: payload }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async addBridge(bridge: ApiBridgeCreate): Promise<ApiBridgeMain | undefined> {
    try {
      const res = await axios.post(`/bridges`, bridge, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateBridge(params: UpdateBridgeParams) {
    const { bridgeId, bridge } = params;
    try {
      const res = await axios.patch(`/bridges/${bridgeId}`, bridge, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async swapBridge(params: SwapBridgeParams) {
    const { bridgeId, payload } = params;
    try {
      const res = await axios.patch(`/bridges/${bridgeId}:swap`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteBridge(bridgeId: DeleteBridgeId) {
    try {
      await axios.delete(`/bridges/${bridgeId}`, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async actionRebootBridgeOrError(bridgeId: BridgeId) {
    return await axios.post(`/bridges/${bridgeId}/actions`, { action: 'reboot' }, this.axiosConfig());
  }

  async getAvailableDevices(
    params: GetAvailableDevicesParams
  ): Promise<ApiPaginatedAvailableDeviceResponse | undefined> {
    const config = Object.assign(this.axiosConfig(), { params });
    try {
      const res = await axios.get('/availableDevices', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getSwitches(): Promise<ApiPaginatedSwitchResponse | undefined> {
    try {
      const res = await axios.get('/switches', this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getSwitchesOrError(payload: GetSwitchesParams): Promise<ApiPaginatedSwitchResponseV2> {
    const { switchId, ...params } = payload;
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/switches`, config);
    return res.data;
  }

  async getSwitch(payload: GetSwitchesParams): Promise<ApiPaginatedSwitchResponse | ApiSwitchWithIncludes | undefined> {
    try {
      const { switchId, ...params } = payload;
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/switches${switchId ? '/' + switchId : ''}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateSwitch(switchId: string, payload: ApiSwitchUpdate): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/switches/${switchId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async actionSwitchPort(payload: SwitchPortActionParam): Promise<number | undefined> {
    try {
      const { portId, switchId, action } = payload;
      const res = await axios.post(`/switches/${switchId}/ports/${portId}/actions`, { action }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async actionSwitchPortOrError(payload: SwitchPortActionParam): Promise<number | undefined> {
    const { portId, switchId, action } = payload;
    const res = await axios.post(`/switches/${switchId}/ports/${portId}/actions`, { action }, this.axiosConfig());
    return res.status;
  }

  async addSwitchToBridge(switchId: string, param: ApiSwitchAdd): Promise<number | undefined> {
    try {
      const res = await axios.post(`/switches/${switchId}/connection`, param, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getFeeds(
    params: GetFeedsParams,
    signal?: AbortSignal,
    uniqueId?: string
  ): Promise<ApiPaginatedFeedResponse | undefined> {
    try {
      if (!params.include) params.include = ['multipartUrl,flvUrl,webRtcUrl'].toString();
      const cancelToken = fromAbortSignal(signal);
      const axiosConfig: {
        baseURL: string;
        withCredentials: boolean;
        headers: { [key: string]: string };
      } = { ...this.axiosConfig() };
      axiosConfig.headers = { ...axiosConfig.headers, 'x-ee-request-id': uniqueId || '' };
      const config: AxiosRequestConfig = Object.assign({}, axiosConfig, {
        params,
        cancelToken: cancelToken.token,
      });
      const res = await axios.get('/feeds', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getPTZPosition(cameraId: GetPTZPositionCameraId): Promise<ApiPtzPosition | undefined> {
    try {
      const res = await axios.get(`/cameras/${cameraId}/ptz/position`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async movePTZ(params: MovePTZParams) {
    const { cameraId, movementData } = params;
    try {
      await axios.put(`/cameras/${cameraId}/ptz/position`, movementData, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async getLocations(
    params?: GetLocationParams,
    locationId?: string,
    signal?: AbortSignal,
    shouldReturnError?: boolean
  ): Promise<PaginatedLocationResponse | undefined> {
    try {
      const config: AxiosRequestConfig = Object.assign({}, this.axiosConfig(), { params });

      if (signal) {
        const cancelToken = fromAbortSignal(signal);
        config.cancelToken = cancelToken.token;
      }

      const res = await axios.get(`/locations${locationId ? '/' + locationId : ''}`, config);
      return res?.data;
    } catch (error) {
      console.log(error);
      if (shouldReturnError) {
        return Promise.reject(error);
      }
    }
  }

  async addLocation(location: Location): Promise<BasicLocationResponse | undefined> {
    try {
      const res = await axios.post(`/locations`, location, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async editLocation(params: EditLocationParams) {
    const { locationId, location } = params;
    try {
      const res = await axios.patch(`/locations/${locationId}`, location, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteLocation(locationId: DeleteLocationId) {
    try {
      const res = await axios.delete(`/locations/${locationId}`, this.axiosConfig());
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  async getLocation(locationId: GetLocationId, params?: Partial<GetLocationParams>): Promise<LocationGet | undefined> {
    const DEFAULT_PARAMS = {
      include: 'notes,address,geometry,childLocationCount,effectivePermissions,resourceStatusCounts,resourceCounts',
    };

    if (!params) params = DEFAULT_PARAMS;

    const config = Object.assign({}, this.axiosConfig(), { params });

    try {
      const res = await axios.get(`/locations/${locationId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getNotifications(params: NotificationParams | undefined): Promise<Notifications | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/notifications', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getNotificationActors(params: NotificationActorsParams | undefined): Promise<NotificationActors | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/notifications:actors', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateNotification(params: UpdateNotificationParams) {
    const { notificationId, payload } = params;
    try {
      const res = await axios.patch(`/notifications/${notificationId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }
  async getRecordedImage(params: RecordedImageParams, signal?: AbortSignal): Promise<RecordedImage | undefined> {
    let data: ArrayBuffer | undefined = undefined;
    let errorMessage: string | undefined = undefined;
    let timestamp: string | undefined = undefined;
    let nextToken: string | undefined = undefined;
    let prevToken: string | undefined = undefined;
    let overlaySvg: string | undefined = undefined;
    const cTokenSource = fromAbortSignal(signal);

    try {
      const config: AxiosRequestConfig = {
        baseURL: (this as unknown as ApiListType).baseURL,
        withCredentials: true,
        responseType: 'arraybuffer',
        cancelToken: cTokenSource.token,
        headers: this.headers(),
        params,
      };

      const res = await axios.get('/media/recordedImage.jpeg', config);
      if (res?.headers['x-een-timestamp']) {
        timestamp = res.headers['x-een-timestamp'];
      }
      if (res?.headers['x-een-nexttoken']) {
        nextToken = res.headers['x-een-nexttoken'];
      }
      if (res?.headers['x-een-prevtoken']) {
        prevToken = res.headers['x-een-prevtoken'];
      }
      if (res?.headers['x-een-overlaysvg']) {
        overlaySvg = res.headers['x-een-overlaysvg'];
      }
      if (res?.data) {
        data = res.data;
      }
    } catch (error) {
      console.log(error);
      const recordedImageError = error as RecordedImageError;
      if (!recordedImageError?.response?.data) {
        errorMessage = undefined;
      } else {
        const errorDetails: RecordedImageErrorDetails = JSON.parse(
          arrayBufferToString(recordedImageError.response.data)
        );
        errorMessage = errorDetails.message;
      }
    }
    return { data, errorMessage, timestamp, prevToken, nextToken, overlaySvg };
  }

  async fetchRecordedImageFieldValues(
    deviceId: string,
    params: RecordedImageFieldValuesParams | undefined = undefined
  ): Promise<PaginatedRecordedImageFieldValuesResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/media/recordedImage.jpeg:listFieldValues?deviceId=${deviceId}`, config);
    return res.data;
  }

  async getLiveImage(deviceId: string): Promise<RecordedImage | undefined> {
    let data: ArrayBuffer | undefined = undefined;
    let errorMessage: string | undefined = undefined;
    let timestamp: string | undefined = undefined;
    try {
      const baseConfig: AxiosRequestConfig = {
        params: { deviceId, type: 'preview' },
        responseType: 'arraybuffer',
      };
      const config = Object.assign({}, this.axiosConfig(), baseConfig);
      const res = await axios.get('/media/liveImage.jpeg', config);
      if (res?.headers['x-een-timestamp']) {
        timestamp = res.headers['x-een-timestamp'];
      }
      if (res?.data) {
        data = res.data;
      }
    } catch (error) {
      console.log(error);
      const recordedImageError = error as RecordedImageError;
      if (!recordedImageError?.response?.data) {
        errorMessage = undefined;
      } else {
        const errorDetails: RecordedImageErrorDetails = JSON.parse(
          arrayBufferToString(recordedImageError.response.data)
        );
        errorMessage = errorDetails.message;
      }
    }
    return { data, errorMessage, timestamp };
  }

  // to fetch images of events served by the media-private API '/eventImage.jpeg'
  async getEventImageByUrl(url: string) {
    try {
      let data: ArrayBuffer | undefined = undefined;
      let config: AxiosRequestConfig = {
        responseType: 'arraybuffer',
        headers: this.headers(),
      };

      const res = await axios.get(url, config);

      if (res?.data) {
        data = res.data;
      }
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  async getMedia(params: mediaMainRequest): Promise<ApiPaginatedMediaResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/media', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getFloors(locationId: GetLocationId): Promise<PaginatedFloorsResponse | undefined> {
    try {
      const res = await axios.get(`/locations/${locationId}/floors`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async addFloor(locationId: GetLocationId, payload: any): Promise<FloorResponse | undefined> {
    try {
      const res = await axios.post(`/locations/${locationId}/floors`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateFloor(locationId: GetLocationId, floorId: GetFloorId, payload: updateFloorParams) {
    try {
      const res = await axios.patch(`/locations/${locationId}/floors/${floorId}`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteFloor(locationId: GetLocationId, floorId: GetFloorId) {
    try {
      await axios.delete(`/locations/${locationId}/floors/${floorId}`, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async getFloorplans(
    locationId: GetLocationId,
    floorId: GetFloorId
  ): Promise<PaginatedFloorplansResponse | undefined> {
    try {
      const res = await axios.get(`/locations/${locationId}/floors/${floorId}/plans`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getFloorplan(locationId: GetLocationId, floorId: GetFloorId, type: string) {
    const res = await axios.get(`/locations/${locationId}/floors/${floorId}.${type}`, this.axiosConfigForBlob());
    return res && res.data;
  }

  async addFloorplan(
    locationId: GetLocationId,
    floorId: GetFloorId,
    formData: FormData
  ): Promise<FloorplanResponse | undefined> {
    try {
      const res = await axios.post(
        `/locations/${locationId}/floors/${floorId}/plans`,
        formData,
        this.axiosConfigForMultipart()
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async getEditions(accountId?: EditionsAccountId): Promise<PaginatedEditionResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), {
        params: { accountId },
      });
      const res = await axios.get(`/editions`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getEdition(editionId: EditionId): Promise<Edition | undefined> {
    try {
      const res = await axios.get(`/editions/${editionId}`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getAccountCapabilities(params: AccountCapabilityParams): Promise<ApiAccountCapabilities | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/accounts/self/capabilities`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getAccount(params: GetAccountsParams): Promise<ApiAccountWithIncludes | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/accounts/self`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async patchAccount(userId: string, payload: ApiAccountPatch) {
    try {
      const res = await axios.patch(`/accounts/${userId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getAlerts(params?: GetAlertsParams, accountId?: string): Promise<ApiPaginatedAlertResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/${accountId ? 'accounts/' + accountId + '/' : ''}alerts`, config);
    return res.data;
  }

  async getAlertListFieldValues(params?: GetAlertListFieldParams): Promise<ApiAlertListFieldResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/alerts:listFieldValues`, config);
    return res.data;
  }

  async getAuditLogFieldValues(): Promise<ApiAuditLogListFieldResponse | undefined> {
    const res = await axios.get('/auditLogAlertConditionRules:createFieldValues', this.axiosConfig());
    return res.data;
  }
  async getRules(params?: GetRulesParams): Promise<ApiPaginatedRuleResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/alertConditionRules`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getAuditLogFiltervalue(
    params: AuditLogListFilterValueRequest
  ): Promise<ApiPaginatedAuditLogsListFilterValue | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/auditLogs:listFilterValues', config);

      return res.data.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getUsers(
    params: GetUsersParams,
    userId: string | undefined
  ): Promise<ApiPaginatedUserResponse | ApiUserWithIncludes | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/users${userId ? '/' + userId : ''}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getLanguages(params: AvailableLanguageRequest): Promise<AvailableLanguageResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/languages', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getAuditLogs(params: AuditLogRequest | undefined): Promise<AuditEvents | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/auditLogs', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getAnalyticSnapshot(params: AnntRequest) {
    try {
      const plainAuthToken = (this as unknown as ApiListType).plainAuthToken;
      if (!plainAuthToken) {
        throw new Error('Auth token not found');
      }
      const config = Object.assign({}, this.axiosConfigForV1Api(), { params });
      const res = await axios.get('/g/analytics/snapshot?A=' + plainAuthToken, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getTags(params: TagsRequest): Promise<TagsList | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/tags', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getUserSelf(): Promise<ApiUserWithIncludes | undefined> {
    try {
      const config = {
        ...this.axiosConfig(),
        params: {
          include: ['support'].toString(),
        },
      };
      const res = await axios.get('/users/self', config);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async passwordResetRequests(userId: string) {
    try {
      const res = await axios.post(`/users/${userId}/passwordResetRequests`, {}, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async patchUser(userId: string, payload: ApiUserSelfUpdate | ApiUserUpdate) {
    try {
      const res = await axios.patch(`/users/${userId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getTimeZones(params: TimeZonesRequest): Promise<TimeZonesList | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/timeZones', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateUserAuthentication(params: ApiAuthentication) {
    try {
      const res = await axios.patch(`/users/self/authentication`, { ...params }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getUserAuthentication() {
    try {
      const res = await axios.get(`/users/self/authentication`, this.axiosConfig());
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  async getUserNotificationSettings(userId: string): Promise<ApiUserNotificationSettings | undefined> {
    try {
      const res: ApiUserNotificationSettings = await axios.get(
        `/users/${userId}/notificationSettings`,
        this.axiosConfig()
      );
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  async patchUserNotificationSettings(
    userId: string,
    payload: ApiUserNotificationSettings
  ): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/users/${userId}/notificationSettings`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async verifyAuthenticationCode(params: ApiAuthenticationCode) {
    try {
      const res = await axios.patch(`/users/self/authentication/code`, { ...params }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getEvents(params: EventsRequestParams, signal?: AbortSignal): Promise<PaginatedEventsResponse | undefined> {
    try {
      const config: AxiosRequestConfig = Object.assign(this.axiosConfig(), {
        params,
      });

      if (signal) {
        const cancelToken = fromAbortSignal(signal);
        config.cancelToken = cancelToken.token;
      }

      if (params.type__in) {
        config.params.type__in = params.type__in.toString();
      }
      if (params.include) {
        config.params.include = params.include.toString();
      }
      const res = await axios.get('/events', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getEventTypes(params: EventTypeRequestParams): Promise<PaginatedEventTypesResponse | undefined> {
    const config = Object.assign(this.axiosConfig(), { params });
    try {
      const res = await axios.get('/eventTypes', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchEventFieldValues(deviceId: string): Promise<PaginatedEventFieldValuesResponse | undefined> {
    const res = await axios.get(`/events:listFieldValues?actor=camera:${deviceId}`, this.axiosConfig());
    return res.data;
  }

  async getResourceGrant(params: CameraAccessRequest): Promise<CameraAccessResponse | undefined> {
    try {
      const { userId, resourceType, ...newParams } = params;
      const config = Object.assign({}, this.axiosConfig(), {
        params: newParams,
      });
      const res = await axios.get(`resourceGrants?resourceType=${resourceType}&userId__in=${userId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async postResourceGrant(payload: ResourceGrants) {
    try {
      const res = await axios.post(`resourceGrants:bulkCreate`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteResourceGrant(payload: ResourceGrants) {
    try {
      const res = await axios.post(`resourceGrants:bulkDelete`, { ids: payload }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteUser(userId: string) {
    try {
      const res = await axios.delete(`/users/${userId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async postUser(payload: ApiAddUser): Promise<ApiUserMain | ApiErrorResponse | undefined> {
    try {
      const res = await axios.post(`/users`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      const err = error as AxiosError;
      return err.response?.data;
    }
  }

  async getUserMessageContext(): Promise<MessageContext | undefined> {
    try {
      const res = await axios.get('/users/self/messageContext', this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getUserPreference(preferenceId: string): Promise<UserPreference | undefined> {
    try {
      const res = await axios.get(`/users/self/preferences/${preferenceId}`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateUserPreference(preferenceId: string, payload: UserPreference): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/users/self/preferences/${preferenceId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteUserPreference(preferenceId: string): Promise<number | undefined> {
    try {
      const res = await axios.delete(`/users/self/preferences/${preferenceId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  //user role settings

  async getUserRoleSettings(userId: string): Promise<userRoleSettings | undefined> {
    try {
      const res = await axios.get(`/users/${userId}/roleSettings`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateUserRoleSettings(userId: string, params: userRoleSettings): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/users/${userId}/roleSettings`, params, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getActions(params?: GetActionsParams, actionId?: string): Promise<ApiPaginatedActionResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/alertActions${actionId ? '/' + actionId : ''}`, config);
    return res.data;
  }

  async postAction(payload: ApiActionCreate) {
    const res = await axios.post(`/alertActions`, payload, this.axiosConfig());
    return res.data;
  }

  async updateAction(actionId: string, payload: ApiActionUpdate) {
    const res = await axios.patch(`/alertActions/${actionId}`, payload, this.axiosConfig());
    return res.status;
  }

  async deleteAction(actionId: string) {
    const res = await axios.delete(`/alertActions/${actionId}`, this.axiosConfig());
    return res.data;
  }

  async getRuleActions(params?: GetActionRulesParams): Promise<ApiPaginatedRuleActionsResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/alertActionRules`, config);
    return res.data;
  }
  async postRuleActions(payload: ApiRuleActionsCreate) {
    const res = await axios.post('/alertActionRules', payload, this.axiosConfig());
    return res.data;
  }

  async updateRuleActions(ruleActionId: string, payload: ApiRuleActionsCreate) {
    const res = await axios.patch(`/alertActionRules/${ruleActionId}`, payload, this.axiosConfig());
    return res.status;
  }
  async deleteRuleActions(ruleId: string) {
    const res = await axios.delete(`/alertActionRules/${ruleId}`, this.axiosConfig());
    return res.data;
  }

  async getAuditLogAlertConditionRules(
    ruleId?: string,
    params?: AuditLogAlertConditionRulesRequest
  ): Promise<PaginatedAuditLogAlertConditionRules | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/auditLogAlertConditionRules${ruleId ? '/' + ruleId : ''}`, config);
    return res.data;
  }

  async addAuditLogAlertConditionRule(
    payload: CreateAuditLogAlertConditionRule
  ): Promise<AuditLogAlertConditionRule | undefined> {
    const res = await axios.post(`/auditLogAlertConditionRules`, payload, this.axiosConfig());
    return res.data;
  }

  async updateAuditLogAlertConditionRule(params: UpdateAuditLogAlertConditionRule) {
    const { ruleId, payload } = params;
    const res = await axios.patch(`/auditLogAlertConditionRules/${ruleId}`, payload, this.axiosConfig());
    return res.status;
  }

  async deleteAuditLogAlertConditionRule(auditLogAlertConditionRuleId: string) {
    await axios.delete(`/auditLogAlertConditionRules/${auditLogAlertConditionRuleId}`, this.axiosConfig());
  }

  // Event Alert Rules Api

  async getEventAlertConditionRules(params?: EventAlertConditionRulesListQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<EventAlertConditionRulesListResponse>('/eventAlertConditionRules', config);

    return res.data;
  }

  async getEventAlertConditionRule(ruleId?: string) {
    const res = await axios.get<EventAlertConditionRuleResponse>(
      `/eventAlertConditionRules/${ruleId}`,
      this.axiosConfig()
    );

    return res.data;
  }

  async getEventAlertConditionRuleFieldValues() {
    const res = await axios.get<EventAlertFieldValuesResponse>(
      '/eventAlertConditionRules:listFieldValues',
      this.axiosConfig()
    );

    return res.data;
  }

  async addEventAlertConditionRule(payload: CreateEventAlertConditionRulePayload) {
    const res = await axios.post<CreateLPRAlertConditionRuleResponse>(
      '/eventAlertConditionRules',
      payload,
      this.axiosConfig()
    );

    return res.data;
  }

  async updateEventAlertConditionRule(params: UpdateEventAlertConditionRule) {
    const { ruleId, payload } = params;
    const res = await axios.patch(`/eventAlertConditionRules/${ruleId}`, payload, this.axiosConfig());
    return res.status;
  }

  async deleteEventAlertConditionRule(eventAlertConditionRuleId: string) {
    await axios.delete(`/eventAlertConditionRules/${eventAlertConditionRuleId}`, this.axiosConfig());
  }

  //

  async getTrustedDevices(params: GetTrustedDevicesParams): Promise<ApiPaginatedTrustedClientResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/users/self/trustedClients', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteTrustedDevice(deviceId: string) {
    try {
      const res = await axios.delete(`/users/self/trustedClients/${deviceId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchCameraSettings(
    cameraId: string,
    params: CameraSettingsQueryParams
  ): Promise<CameraSettingsResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const response = await axios.get<CameraSettingsResponse>(`/cameras/${cameraId}/settings`, config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async patchCameraSettings(cameraId: string, payload: PatchCameraSettings): Promise<number | undefined> {
    try {
      const response = await axios.patch(`/cameras/${cameraId}/settings`, payload, this.axiosConfig());
      return response.status;
    } catch (error) {
      console.log(error);
    }
  }

  // To fetch image by passing image URL and it supports params as well

  async getImageByUrl(
    url: string,
    cTokenSource: CancelTokenSource,
    params?: RecordedImageParams
  ): Promise<RecordedImage | undefined> {
    let data: ArrayBuffer | undefined = undefined;
    let errorMessage: string | undefined = undefined;
    let timestamp: string | undefined = undefined;
    try {
      let config: AxiosRequestConfig = {
        withCredentials: true,
        responseType: 'arraybuffer',
        cancelToken: cTokenSource.token,
        headers: this.headers(),
      };

      if (params) config.params = params;

      const res = await axios.get(url, config);

      if (res?.data) {
        data = res.data;
      }
    } catch (error) {
      const recordedImageError = error as RecordedImageError;

      if (!recordedImageError?.response.data) {
        errorMessage = undefined;
      } else {
        const errorDetails: RecordedImageErrorDetails = JSON.parse(
          arrayBufferToString(recordedImageError.response.data)
        );

        errorMessage = errorDetails.message;
      }
    }

    return { data, errorMessage, timestamp };
  }

  /**
   * LPR APIs
   */

  // LPR Vehicle list APIs

  async fetchLPRVehicleLists(params?: LPRVehicleListsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRVehicleListsResponse>('/lprVehicleLists', config);

    return res.data;
  }

  async createLPRVehicleList(payload: CreateLPRVehicleListRequestPayload) {
    const res = await axios.post<CreateLPRVehicleListResponse>('/lprVehicleLists', payload, this.axiosConfig());

    return res.data;
  }

  async fetchLPRVehicleListsFields() {
    const res = await axios.get<LPRVehicleListsFieldsResponse>('/lprVehicleLists:listFields', this.axiosConfig());

    return res.data;
  }

  async fetchLPRVehicleListsFieldValues() {
    const res = await axios.get<LPRVehicleListsFieldValuesResponse>(
      '/lprVehicleLists:listFieldValues',
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchLPRVehicleList(id: string) {
    const res = await axios.get<LPRVehicleListResponse>(`/lprVehicleLists/${id}`, this.axiosConfig());

    return res.data;
  }

  async updateLPRVehicleList(id: string, payload: UpdateLPRVehicleListRequestPayload) {
    await axios.patch(`/lprVehicleLists/${id}`, payload, this.axiosConfig());
  }

  async deleteLPRVehicleList(id: string) {
    await axios.delete(`/lprVehicleLists/${id}`, this.axiosConfig());
  }

  async fetchLPRVehicleRecordsInList(id: string, params?: LPRVehicleRecordsInListQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRVehicleRecordsInListResponse>(`/lprVehicleLists/${id}/vehicles`, config);

    return res.data;
  }

  async addNewLPRVehicleRecordToList(id: string, payload: AddNewLPRVehicleRecordInListRequestPayload) {
    const res = await axios.post<AddNewLPRVehicleRecordInListResponse>(
      `/lprVehicleLists/${id}/vehicles`,
      payload,
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchLPRVehicleRecordInList(id: string, recordID: string) {
    const res = await axios.get<LPRVehicleRecordInListResponse>(
      `/lprVehicleLists/${id}/vehicles/${recordID}`,
      this.axiosConfig()
    );

    return res.data;
  }

  async updateLPRVehicleRecordInList({
    id,
    recordID,
    payload,
  }: {
    id: string;
    recordID: string;
    payload: UpdateLPRVehicleRecordInListRequestPayload;
  }) {
    await axios.patch(`/lprVehicleLists/${id}/vehicles/${recordID}`, payload, this.axiosConfig());
  }

  async deleteLPRVehicleRecordInList(id: string, recordID: string) {
    await axios.delete(`/lprVehicleLists/${id}/vehicles/${recordID}`, this.axiosConfig());
  }

  async addNewLPRVehicleRecordsToListinBulk(id: string, payload: AddNewLPRVehicleRecordInListRequestPayload[]) {
    try {
      const res = await axios.post<LPRVehicleRecordBulkCreateResponse>(
        `/lprVehicleLists/${id}/vehicles:bulkCreate`,
        payload,
        this.axiosConfig()
      );

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async searchLPRVehicleRecordsInList(params?: LPRVehicleRecordsInAllListsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRVehicleRecordsInAllListsResponse>('/lprVehicleLists:search', config);

    return res.data;
  }

  // LPR Rules APIs

  async createLPRAlertConditionRule(payload: CreateLPRAlertConditionRuleRequestPayload) {
    const res = await axios.post<CreateLPRAlertConditionRuleResponse>(
      '/lprAlertConditionRules',
      payload,
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchLPRAlertConditionRules(params?: LPRAlertConditionRulesListQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRAlertConditionRulesListResponse>('/lprAlertConditionRules', config);

    return res.data;
  }

  async fetchLPRAlertConditionRulesFieldValues() {
    const res = await axios.get<LPRAlertConditionRulesListFieldValuesResponse>(
      '/lprAlertConditionRules:listFieldValues',
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchLPRAlertConditionRule(id: string) {
    const res = await axios.get<LPRAlertConditionRuleResponse>(`/lprAlertConditionRules/${id}`, this.axiosConfig());

    return res.data;
  }

  async updateLPRAlertConditionRule(id: string, payload: UpdateLPRAlertConditionRuleRequestPayload) {
    await axios.patch(`/lprAlertConditionRules/${id}`, payload, this.axiosConfig());
  }

  async deleteLPRAlertConditionRule(id: string) {
    await axios.delete(`/lprAlertConditionRules/${id}`, this.axiosConfig());
  }

  // LPR Events APIs

  async fetchLPREvents(params?: LPREventsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPREventsResponse>('/lprEvents', config);

    return res.data;
  }

  async fetchLPREvent(id: string, params?: LPREventQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPREventResponse>(`/lprEvents/${id}`, config);

    return res.data;
  }

  async fetchLPREventsSummary(params?: LPREventsSummaryQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPREventsSummaryResponse>('/lprEvents:summary', config);

    return res.data;
  }

  async fetchLPREventsFieldValues() {
    const res = await axios.get<LPREventsFieldValuesResponse>('/lprEvents:listFieldValues', this.axiosConfig());

    return res.data;
  }

  /**
   * Alerts APIs - prefixed with LPR inorder to avoid naming collisions with old alerts APIs
   */

  async fetchLPRAccountAlerts(id: string, params?: LPRAcccountAlertsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRAccountAlertsResponse>(`/accounts/${id}/alerts`, config);

    return res.data;
  }

  async fetchLPRAlerts(params?: LPRAlertsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRAlertsResponse>('/alerts', config);

    return res.data;
  }

  async fetchLPRAlert(id: string) {
    const res = await axios.get<LPRAlertResponse>(`/alerts/${id}`, this.axiosConfig());

    return res.data;
  }

  async getArchives(
    payload: GetFilesParams,
    resourceId?: string,
    signal?: AbortSignal
  ): Promise<ApiPaginatedFileResponse | ApiFileWithIncludes | undefined> {
    try {
      const { ...params } = payload;

      const config: AxiosRequestConfig = Object.assign({}, this.axiosConfig(), { params });

      if (signal) {
        const cancelToken = fromAbortSignal(signal);
        config.cancelToken = cancelToken.token;
      }

      const res = await axios.get(`/files${resourceId ? '/' + resourceId : ''}`, config);
      return res?.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteFile(fileId: string): Promise<number | undefined> {
    try {
      const res = await axios.delete(`/files/${fileId}`, this.axiosConfig());

      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async updateFile(fileId: string, params: UpdateFileParams) {
    try {
      const res = await axios.patch(`/files/${fileId}`, params, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async copyFile(fileId: string, params: UpdateFileParams) {
    try {
      const res = await axios.patch(`/files/${fileId}:copy`, params, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async createNewFile(params: NewFileParams) {
    try {
      const res = await axios.post(`/files`, params, this.axiosConfig());
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Export api's
   */

  async postExport(payload: ExportDetails): Promise<ApiCreateExportResponse | undefined> {
    try {
      const res = await axios.post(`/exports`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async createJob(payload: CreateJobRequestPayload) {
    try {
      const res = await axios.post(`/jobs`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchJob(jobId?: string): Promise<Job | undefined> {
    const config = Object.assign({}, this.axiosConfig());
    try {
      const res = await axios.get(`/jobs/${jobId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchJobs(params: GetJobsParams, jobId?: string): Promise<PaginatedJobResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/jobs${jobId ? '/' + jobId : ''}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteJob(jobId: string): Promise<void> {
    try {
      await axios.delete('/jobs/' + jobId, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async fetchDownloads(payload: GetFilesParams, signal?: AbortSignal) {
    const { ...params } = payload;
    const config: AxiosRequestConfig = Object.assign({}, this.axiosConfig(), { params });

    if (signal) {
      const cancelToken = fromAbortSignal(signal);
      config.cancelToken = cancelToken.token;
    }

    try {
      const res = await axios.get('/downloads', config);
      return res?.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteDownload(fileId: string) {
    try {
      await axios.delete(`/downloads/${fileId}`, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async updateDownload(fileId: string, params: UpdateDownloadParams) {
    try {
      const res = await axios.patch(`/downloads/${fileId}`, params, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Alert rules APIs
   */

  // Alert condition rules

  async fetchAlertConditionRules(params?: AlertConditionRulesQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<AlertConditionRulesResponse>(`/alertConditionRules`, config);

    return res.data;
  }

  async fetchAlertConditionRule(id: string) {
    const res = await axios.get<AlertConditionRuleResponse>(`/alertConditionRules/${id}`, this.axiosConfig());

    return res.data;
  }

  async updateAlertConditionRule(id: string, payload: UpdateAlertConditionRuleRequestPayload) {
    await axios.patch(`/alertConditionRules/${id}`, payload, this.axiosConfig());
  }

  // Alert action rules

  async createAlertActionRule(payload: CreateAlertActionRuleRequestPayload) {
    const res = await axios.post<CreateAlertActionRuleResponse>('/alertActionRules', payload, this.axiosConfig());

    return res.data;
  }

  async fetchAlertActionRules(params?: AlertActionRulesQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<AlertActionRulesResponse>(`/alertActionRules`, config);

    return res.data;
  }

  async fetchAlertActionRule(id: string) {
    const res = await axios.get<AlertActionRuleResponse>(`/alertActionRules/${id}`, this.axiosConfig());

    return res.data;
  }

  async updateAlertActionRule(id: string, payload: UpdateAlertActionRuleRequestPayload) {
    await axios.patch(`/alertActionRules/${id}`, payload, this.axiosConfig());
  }

  async deleteAlertActionRule(id: string) {
    await axios.delete(`/alertActionRules/${id}`, this.axiosConfig());
  }

  // Alert actions

  async createAlertAction(payload: CreateAlertActionRequestPayload) {
    const res = await axios.post<CreateAlertActionResponse>('/alertActions', payload, this.axiosConfig());

    return res.data;
  }

  async fetchAlertActions(params?: AlertActionsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<AlertActionsResponse>(`/alertActions`, config);

    return res.data;
  }

  async fetchAlertAction(id: string) {
    const res = await axios.get<AlertActionResponse>(`/alertActions/${id}`, this.axiosConfig());

    return res.data;
  }

  async updateAlertAction(id: string, payload: UpdateAlertActionRequestPayload) {
    await axios.patch(`/alertActions/${id}`, payload, this.axiosConfig());
  }

  async deleteAlertAction(id: string) {
    await axios.delete(`/alertActions/${id}`, this.axiosConfig());
  }

  async fetchAccountCameraCredentials(id: string, params: GetAccountCameraCredentialsParams) {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get<ApiAccountPaginatedCredentials>(`/accounts/${id}/credentials`, config);

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async addAccountCameraCredentials(id: string, credential: AddAccountCameraCredentialsParams) {
    try {
      const res = await axios.post<ApiAccountPaginatedCredentials>(
        `/accounts/${id}/credentials`,
        credential,
        this.axiosConfig()
      );
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteAccountCameraCredentials(id: string, credentialId: string) {
    try {
      const res = await axios.delete(`/accounts/${id}/credentials/${credentialId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async reTryExport(jobId: string, param: ApiCopyExportBody): Promise<ApiCopyExportResponse | undefined> {
    try {
      const res = await axios.post<ApiCopyExportResponse>(`/exports/${jobId}:copy`, param, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async createDeviceTunnel(
    deviceId: string,
    type: 'multiCameras' | 'cameras' | 'speakers' | 'availableDevices',
    param?: CreateTunnelParam
  ): Promise<CameraTunnelResponse | undefined> {
    try {
      const res = await axios.put(`/${type}/${deviceId}/tunnel`, { ...param }, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteDeviceTunnel(
    deviceId: string,
    type: 'multiCameras' | 'cameras' | 'speakers' | 'availableDevices'
  ): Promise<number | undefined> {
    try {
      const res = await axios.delete(`/${type}/${deviceId}/tunnel`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchDeviceMetrics(deviceId: string, api: 'cameras' | 'bridges', params: GetMetricsParams) {
    const queryParameters: Omit<GetMetricsParams, 'target__in'> & {
      target__in: string | string[];
    } = params;
    queryParameters.target__in = params.target__in.toString();
    try {
      const config = Object.assign({}, this.axiosConfig(), {
        params: queryParameters,
      });
      const res = await axios.get<MetricQueryResponse>(`/${api}/${deviceId}/metrics`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getEventMetrics(params: GetEventMetricsParams): Promise<EventMetricsGetResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });

    try {
      const res = await axios.get('/eventMetrics', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Video search APIs
   */

  // Object class types

  async fetchVSObjectClasses() {
    const res = await axios.get<VSObjectClassResponse>('/videoAnalyticEvents/objectClass', this.axiosConfig());

    return res.data;
  }

  async fetchVSObjectClassAttributes(objClass: string) {
    const res = await axios.get<VSObjectClassAttributesResponse>(
      `/videoAnalyticEvents/objectClass/${objClass}`,
      this.axiosConfig()
    );

    return res.data;
  }

  // Video analytics events

  async fetchVSAttributesForAnNLPQuery(
    params: VSMapNLQueryToAttributesQueryParams,
    payload: VSMapNLQueryToAttributesRequestPayload
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.post<VSMapNLQueryToAttributesResponse>('/videoAnalyticEvents:parse', payload, config);

    return res.data;
  }

  async fetchVSEventsByDeepSearch(
    params: VSEventsDeepSearchQueryParams,
    payload: VSEventsDeepSearchRequestPayload,
    signal?: AbortSignal
  ) {
    const config: AxiosRequestConfig = Object.assign({}, this.axiosConfig(), { params });

    if (signal) {
      const cancelToken = fromAbortSignal(signal);
      config.cancelToken = cancelToken.token;
    }

    const res = await axios.post<VSEventsDeepSearchResponse>('/videoAnalyticEvents:deepSearch', payload, config);

    return res.data;
  }

  async fetchVSEvent(id: string, params: VSEventQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.get<VSEventResponse>(`/videoAnalyticEvents/${id}`, config);

    return res.data;
  }

  async fetchVSEventsByGroup(params: VSEventsGroupSearchQueryParams, payload: VSEventsGroupSearchRequestPayload) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.post<VSEventsGroupSearchResponse>(
      '/videoAnalyticEvents:deepSearchGroupByResource',
      payload,
      config
    );

    return res.data;
  }

  async fetchVSEventsByTimeGroup(
    params: VSEventsTimeGroupSearchQueryParams,
    payload: VSEventsTimeGroupSearchRequestPayload
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.post<VSEventsTimeGroupSearchResponse>(
      '/videoAnalyticEvents:deepSearchGroupByTime',
      payload,
      config
    );

    return res.data;
  }

  async fetchVSEventsFieldValues(
    params: VSEventsListFieldValuesQueryParams,
    payload: VSEventsListFieldValuesRequestPayload
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.post<VSEventsListFieldValuesResponse>(
      '/videoAnalyticEvents:listFieldValues',
      payload,
      config
    );

    return res.data;
  }

  async fetchVSEventsObjectValues(params: VSEventsListObjectValuesQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.get<VSEventsListObjectValuesResponse>('/videoAnalyticEvents:listObjectValues', config);

    return res.data;
  }

  async fetchFaceSearchEventByID(faceId: string, params: VSFaceSearchEventQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.get<VSFaceSearchEventResponse>(`/videoAnalyticEvents/${faceId}`, config);

    return res.data;
  }

  async getSSOAuthSettings(params: GetSSOSettingsParams): Promise<ApiAuthSettings | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get<ApiAuthSettings>('/accounts/self/ssoAuthSettings', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async patchSSOAuthSettings(payload: ApiAuthSettingsUpdate): Promise<number | undefined> {
    try {
      const res = await axios.patch('/accounts/self/ssoAuthSettings', payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchSpeakerSettings(
    speakerId: string,
    params?: SpeakerSettingsQueryParams
  ): Promise<AdvancedSpeakerSettings | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const response = await axios.get<AdvancedSpeakerSettings>(`/speakers/${speakerId}/settings`, config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async patchSpeakerSettings(speakerId: string, payload: AdvancedSpeakerSettings): Promise<number | undefined> {
    try {
      const response = await axios.patch(`/speakers/${speakerId}/settings`, payload, this.axiosConfig());
      return response.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getMultiCamera(
    multiCameraId: string,
    params: GetMultiCameraParams
  ): Promise<ApiMultiCameraWithIncludes | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/multiCameras/${multiCameraId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getMultiCamerasOrError(params: GetMultiCamerasParams): Promise<ApiPaginatedMultiCameraResponse> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get('/multiCameras', config);
    return res.data;
  }

  async patchMultiCamera(multiCameraId: string, payload: ApiMultiCameraUpdate): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/multiCameras/${multiCameraId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getMultiCameraChannels(
    multiCameraId: string,
    params: PaginationQueryParams
  ): Promise<ApiPaginatedMultiCameraChannelResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/multiCameras/${multiCameraId}/channels`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getMultiCameraSettings(
    multiCameraId: string,
    params: MultiCameraSettingsQueryParams
  ): Promise<MultiCameraSettingsGet | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/multiCameras/${multiCameraId}/settings`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateMultiCameraSettings(
    multiCameraId: string,
    payload: UpdateMultiCameraSettings
  ): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/multiCameras/${multiCameraId}/settings`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * POS APIs
   */

  // Transactions APIs

  async fetchPOSEvents(params?: POSEventsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<POSEventsResponse>('/posEvents', config);

    return res.data;
  }

  async fetchPOSEvent(id: string, params?: POSEventQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<POSEventResponse>(`/posEvents/${id}`, config);

    return res.data;
  }

  async updatePOSEvent(id: string, payload: POSEventUpdateTransactionFlagPayload) {
    await axios.patch(`/posEvents/${id}`, payload, this.axiosConfig());
  }

  async fetchPOSEventsFieldValues() {
    const res = await axios.get<POSEventFieldValuesResponse>('/posEvents:listFieldValues', this.axiosConfig());

    return res.data;
  }

  async connectToPosTerminal(body: PosOAuthLogin) {
    return await axios.post<PoSOAuthLoginResponse>('/pos/oauth2/login', body, this.axiosConfigForExternal());
  }

  async getPoSIntegrations(params?: PoSIntegrationParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    return await axios.get<PoSIntegrationResponse>(`/posIntegrations`, config);
  }

  async getPoSIntegration(id: string) {
    return await axios.get<PoSIntegrationData>(`/posIntegrations/${id}`, this.axiosConfig());
  }

  async updatePoSIntegration(id: string, payload: UpdatePoSIntegrationRequest) {
    return await axios.patch(`/posIntegrations/${id}`, payload, this.axiosConfig());
  }

  async getAvailablePoSRegisters(integrationID: string, params: AvailableRegistersQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    return await axios.get<AvailablePoSRegistersResponse>(
      `/posIntegrations/${integrationID}/availableRegisters`,
      config
    );
  }

  async createPoSRegister(payload: CreatePoSRegister) {
    return await axios.post<PoSRegisterResponse>('/posRegisters', payload, this.axiosConfig());
  }

  async getPoSRegisters(params: GetPoSRegistersQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    return await axios.get<GetPoSRegistersResponse>('/posRegisters', config);
  }

  async getPoSRegister(id: string, params: GetPoSRegistersQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    return await axios.get<PoSRegisterResponse>(`/posRegisters/${id}`, config);
  }

  async updatePoSRegister(id: string, payload: UpdatePoSRegister) {
    return await axios.patch(`/posRegisters/${id}`, payload, this.axiosConfig());
  }

  async deletePoSRegister(id: string) {
    return await axios.delete(`/posRegisters/${id}`, this.axiosConfig());
  }

  async fetchPOSSummary(params: PoSSummaryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      return await axios.get<PoSSummaryResponse>('/posEvents:summary', config);
    } catch (error) {
      return error;
    }
  }

  async fetchPtzSettings(params: PtzSettingsQueryParams) {
    const res = await axios.get<PtzSettings>(`/cameras/${params.cameraId}/ptz/settings`, this.axiosConfig());
    return res.data;
  }

  async updatePtzSettings(params: PtzSettingsQueryParams, payload: PtzSettings): Promise<number | undefined> {
    const res = await axios.patch(`/cameras/${params.cameraId}/ptz/settings`, payload, this.axiosConfig());
    return res.status;
  }

  /** Sensor Gateways */
  async getSensorGateways(params: GetGatewaysParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiPaginatedGatewayResponse>('/sensorGateways', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getSensorGateway(params: GetGatewaysParams, id: string) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiGatewayWithIncludes>(`/sensorGateways/${id}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateSensorGateway(payload: ApiGatewayUpdate, id: string) {
    try {
      const res = await axios.patch(`/sensorGateways/${id}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async addSensorGateway(sensorGateway: ApiGatewayCreate) {
    try {
      const res = await axios.post<ApiGatewayCreate>(`/sensorGateways`, sensorGateway, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteSensorGateway(id: string) {
    try {
      const res = await axios.delete(`/sensorGateways/${id}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  /** Available Sensor Devices */
  async getAvailableSensors(params: GetAvailableSensorDevicesParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiPaginatedAvaibleSensorDeviceResponse>('/availableSensorDevices', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  /** Sensor Summary */
  async getSensorSummary(params: GetSensorSummaryRequestParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiSensorSummaryResponse>('/sensorSummary', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  /** Sensor Devices */
  async getSensorDevices(params: GetSensorDevicesParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiPaginatedSensorDeviceResponse>('/sensorDevices', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getSensorDevice(params: GetSensorDevicesParams, id: string) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiSensorDeviceWithIncludes>(`/sensorDevices/${id}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateSensorDevice(payload: ApiSensorDeviceUpdate, id: string) {
    try {
      const res = await axios.patch(`/sensorDevices/${id}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async addSensorDevice(sensorDevice: ApiSensorDeviceCreate) {
    try {
      const res = await axios.post<ApiSensorDeviceMain>(`/sensorDevices`, sensorDevice, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteSensorDevice(id: string) {
    try {
      const res = await axios.delete(`/sensorDevices/${id}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  /** Measurement Thresholds */
  async getMeasurementThresholds(params: GetMeasurementThresholdsParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiPaginatedMeasurementThresholdResponse>('/measurementThresholds', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getMeasurementThreshold(params: GetMeasurementThresholdsParams, id: string) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiMeasurementThresholdWithIncludes>(`/measurementThresholds/${id}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateMeasurementThreshold(payload: ApiMeasurementThresholdUpdate, id: string) {
    try {
      const res = await axios.patch(`/measurementThresholds/${id}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async addMeasurementThreshold(measurementThreshold: ApiMeasurementThresholdCreate) {
    try {
      const res = await axios.post<ApiMeasurementThresholdMain>(
        `/measurementThresholds`,
        measurementThreshold,
        this.axiosConfig()
      );
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteMeasurementThreshold(id: string) {
    try {
      const res = await axios.delete(`/measurementThresholds/${id}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  /** Measurement Field Values */
  async getMeasurementFieldValues(params: GetMeasurementFieldValuesParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiMeasurementFieldValuesWithIncludes>('/measurements:listFieldValues', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  /** Measurements */
  async getMeasurements(params: GetMeasurementsParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiPaginatedMeasurementsResponse>('/measurements', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getMeasurement(params: GetMeasurementsParams, id: string) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiMeasurementWithIncludes>(`/measurements/${id}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateMeasurement(payload: ApiMeasurementUpdate, id: string) {
    try {
      const res = await axios.patch(`/measurements/${id}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  /** Sensor Time Series */
  async getSensorTimeSeries(params: GetSensorTimeSeriesParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiPaginatedSensorTimeSeriesResponse>('/sensorTimeSeries', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getSingleSensorTimeSeries(params: GetSensorTimeSeriesParams, id: string) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get<ApiSensorTimeSeriesMain>(`/sensorTimeSeries/${id}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * @description Retrieves the complete dewarp configuration, including a list of all composites and panes
   * associated with it. In a format that can be directly used with the dewarp SDK.
   */
  async getDewarpConfig(cameraId: string) {
    const res = await axios.get<ApiDewarpConfig>(`/cameras/${cameraId}/dewarp/config`, this.axiosConfig());
    return res.data;
  }

  async updateDewarpConfig(cameraId: string, payload: DewarpConfigUpdate): Promise<number | undefined> {
    const res = await axios.patch(`/cameras/${cameraId}/dewarp/config`, payload, this.axiosConfig());
    return res.status;
  }

  /**
   * @description Get individual composite object by it's uuid
   */
  async getComposite(cameraId: string, compositeId: string) {
    const res = await axios.get<ApiDewarpConfigComposite>(
      `/cameras/${cameraId}/dewarp/composites/${compositeId}`,
      this.axiosConfig()
    );
    return res.data;
  }

  async getEventSubscriptions(params: PaginationQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<ApiPaginatedEventSubscriptionsResponse>('/eventSubscriptions', config);
    return res.data;
  }

  async createEventSubscription(payload: EventSubscriptionCreate) {
    const res = await axios.post<EventSubscription>('/eventSubscriptions', payload, this.axiosConfig());
    return res.data;
  }

  async deleteEventSubscription(eventSubscriptionId: string): Promise<number | undefined> {
    const res = await axios.delete<EventSubscription>(`/eventSubscriptions/${eventSubscriptionId}`, this.axiosConfig());
    return res.status;
  }

  async createEventSubscriptionFilter(eventSubscriptionId: string, payload: FilterCreate): Promise<Filter | undefined> {
    const res = await axios.post(`/eventSubscriptions/${eventSubscriptionId}/filters`, payload, this.axiosConfig());
    return res.data;
  }

  async deleteEventSubscriptionFilter(eventSubscriptionId: string, filterId: string): Promise<number | undefined> {
    const res = await axios.delete(
      `/eventSubscriptions/${eventSubscriptionId}/filters/${filterId}`,
      this.axiosConfig()
    );
    return res.status;
  }

  async deleteComposite(compositeId: string, cameraId: string) {
    try {
      const res = await axios.delete(`/cameras/${cameraId}/dewarp/composites/${compositeId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async addComposite(cameraId: string, payload: ApiDewarpConfigComposite): Promise<number | undefined> {
    try {
      const res = await axios.post(`/cameras/${cameraId}/dewarp/composites`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async updateComposite(cameraId: string, payload: ApiDewarpConfigComposite): Promise<number | undefined> {
    try {
      const res = await axios.patch(
        `/cameras/${cameraId}/dewarp/composites/${payload.id}`,
        payload,
        this.axiosConfig()
      );
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * First responders api's
   */

  async getResponders(
    accountId: string,
    params: PaginationQueryParams
  ): Promise<PaginatedResponderResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });

    try {
      const res = await axios.get(`/accounts/${accountId}/firstResponders/responders`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async createResponders(accountId: string, payload: ResponderBulkCreate): Promise<BulkResponseResponders | undefined> {
    try {
      const res = await axios.post(
        `/accounts/${accountId}/firstResponders/responders:bulkCreate`,
        payload,
        this.axiosConfig()
      );
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateResponder(accountId: string, email: string, payload: ResponderPatch): Promise<number | undefined> {
    try {
      const res = await axios.patch(
        `/accounts/${accountId}/firstResponders/responders/${email}`,
        payload,
        this.axiosConfig()
      );
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteResponders(accountId: string, payload: ResponderBulkDelete): Promise<BulkResponseResponders | undefined> {
    try {
      const res = await axios.post(
        `/accounts/${accountId}/firstResponders/responders:bulkDelete`,
        payload,
        this.axiosConfig()
      );
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getResponderCameras(accountId: string): Promise<PaginatedCameraResponse | undefined> {
    try {
      const res = await axios.get(`/accounts/${accountId}/firstResponders/cameras`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async createResponderCameras(
    accountId: string,
    payload: ResponderCameraBulkCreate
  ): Promise<BulkResponseCameras | undefined> {
    try {
      const res = await axios.post(
        `/accounts/${accountId}/firstResponders/cameras:bulkCreate`,
        payload,
        this.axiosConfig()
      );
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteResponderCameras(
    accountId: string,
    payload: ResponderCameraBulkDelete
  ): Promise<BulkResponseCameras | undefined> {
    try {
      const res = await axios.post(
        `/accounts/${accountId}/firstResponders/cameras:bulkDelete`,
        payload,
        this.axiosConfig()
      );
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Roles api's
   */

  async getRoles(params?: GetRolesParams): Promise<PaginatedRolesResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });

    try {
      const res = await axios.get('/roles', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async addRoles(payload: CreateRolesParams): Promise<CreateRolesResponse | ApiErrorResponse | undefined> {
    try {
      const res = await axios.post('/roles', payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
      const err = error as AxiosError;
      return err.response?.data;
    }
  }

  async deleteRole(roleId: string): Promise<number | undefined> {
    try {
      const res = await axios.delete(`/roles/${roleId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getRole(roleId: string, params: GetRoleParams): Promise<Role | undefined> {
    const { include } = params;
    const config = Object.assign({}, this.axiosConfig(), { params: { include } });

    try {
      const res = await axios.get(`/roles/${roleId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async patchRole(roleId: string, payload: UpdateRolePayload): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/roles/${roleId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getRoleAssignments(params: GetRoleAssignmentsParams): Promise<GetRoleAssignmentResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });

    try {
      const res = await axios.get('/roleAssignments', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async createBulkRoleAssignments(
    payload: ApiBulkCreateRoleAssignment
  ): Promise<ApiBulkRoleAssignmentResponse | undefined> {
    try {
      const res = await axios.post('/roleAssignments:bulkcreate', payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async bulkDeleteRoleAssignments(
    payload: ApiBulkDeleteRoleAssignment
  ): Promise<ApiBulkDeleteRoleAssignmentResponse | undefined> {
    try {
      const res = await axios.post('/roleAssignments:bulkdelete', payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Report api's
   */

  async fetchReportSchedules(params?: ReportSchedulesQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<PaginatedReportScheduleResourceResponse>(`/reportSchedules`, config);
    return res.data;
  }

  async createReportSchedule(payload: CreateReportScheduleRequestPayload) {
    const res = await axios.post<ReportScheduleResourceResponse>('/reportSchedules', payload, this.axiosConfig());
    return res.data;
  }

  async fetchReports(params?: ReportsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<PaginatedReportResourceResponse>(`/reports`, config);
    return res.data;
  }

  async runReportSchedule(reportScheduleId: string) {
    const res = await axios.post<ReportResource>(`/reportSchedules/${reportScheduleId}:run`, {}, this.axiosConfig());
    return res.data;
  }

  async fetchCameraIOSettings(
    cameraId: string,
    params: CameraIOSettingsQueryParams
  ): Promise<PaginatedCameraIOSettingsPortResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const response = await axios.get<PaginatedCameraIOSettingsPortResponse>(`/cameras/${cameraId}/io/ports`, config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateCameraIOSettings(cameraId: string, portId: string, params: PortPatch): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/cameras/${cameraId}/io/ports/${portId}`, params, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getAnalyticsSettings(cameraId: string): Promise<ApiPaginatedAnalyticsSettingsResponse | undefined> {
    try {
      const response = await axios.get<ApiPaginatedAnalyticsSettingsResponse>(
        `/cameras/${cameraId}/analyticsSettings`,
        this.axiosConfig()
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getAnalyticsSettingsByType(cameraId: string, type: AnalyticsType): Promise<AnalyticsSettingsGet | undefined> {
    try {
      const response = await axios.get<AnalyticsSettingsGet>(
        `/cameras/${cameraId}/analyticsSettings/${type}`,
        this.axiosConfig()
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async bulkUpdateAnalyticsSettings(
    cameraId: string,
    params: AnalyticsSettingsPatch[]
  ): Promise<BulkUpdateResponses | undefined> {
    try {
      const response = await axios.post(
        `/cameras/${cameraId}/analyticsSettings:bulkUpdate`,
        params,
        this.axiosConfig()
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateAnalyticsSettingsByType(
    cameraId: string,
    type: AnalyticsType,
    params: AnalyticsSettingsPatchSingle
  ): Promise<number | undefined> {
    try {
      const response = await axios.patch(`/cameras/${cameraId}/analyticsSettings/${type}`, params, this.axiosConfig());
      return response.status;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Delegates api's
   */

  async getDelegates(params?: GetDelegatesParams): Promise<PaginatedDelegateResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });

    try {
      const res = await axios.get('/delegates', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async addDelegates(payload: CreateDelegate): Promise<CreateDelegateResponse | undefined> {
    try {
      const res = await axios.post('/delegates', payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateDelegate(delegateId: string, payload: UpdateDelegate): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/delegates/${delegateId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getDelegate(delegateId: string, params: GetDelegatesParams): Promise<Delegates | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/delegates/${delegateId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteDelegate(delegateId: string): Promise<number | undefined> {
    try {
      const res = await axios.delete(`/delegates/${delegateId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getPaginatedDelegateGrants(
    params: GetDelegatesGrantParams
  ): Promise<ApiPaginatedDelegateGrantResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get('/delegateGrants', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async createDelegateGrants(payload: DelegateGrantsBulkCreate): Promise<BulkCreateDelegateGrantResponse | undefined> {
    try {
      const res = await axios.post('/delegateGrants:bulkCreate', payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteDelegateGrants(payload: DelegateGrantsBulkDelete): Promise<BulkDeleteDelegateGrantResponse | undefined> {
    try {
      const res = await axios.post('/delegateGrants:bulkDelete', payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getShares(params: GetSharesParams): Promise<PaginatedShareResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/accounts/self/shares`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async createShares(payload: ShareCreate): Promise<Share | undefined> {
    try {
      const res = await axios.post(`/accounts/self/shares`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteShares(shareId: string): Promise<number | undefined> {
    try {
      const res = await axios.delete(`/accounts/self/shares/${shareId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getSpeceficShare(shareId: string): Promise<Share | undefined> {
    try {
      const res = await axios.get(`/accounts/self/shares/${shareId}`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateSharesPermission(shareId: string, payload: ShareUpdate): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/accounts/self/shares/${shareId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchSharedResourceGrants(shareId: string): Promise<PaginatedShareResourcesResponse | undefined> {
    try {
      const res = await axios.get(`/accounts/self/shares/${shareId}/resourceGrants`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async bulkDeleteSharesResourceGrants(shareId: string, payload: SharesBulkDelete): Promise<number | undefined> {
    try {
      const res = await axios.post(
        `/accounts/self/shares/${shareId}/resourceGrants:bulkDelete`,
        payload,
        this.axiosConfig()
      );
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }
  async bulkCreateSharesResourceGrants(shareId: string, payload: SharesBulkCreate): Promise<number | undefined> {
    try {
      const res = await axios.post(
        `/accounts/self/shares/${shareId}/resourceGrants:bulkCreate`,
        payload,
        this.axiosConfig()
      );
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getCameraTunnel(params: CameraTunnelParams, authToken: string, signal?: AbortSignal) {
    try {
      const cancelToken = fromAbortSignal(signal);
      const res = await axios.put(
        `/g/cameratunnel?A=${authToken}`,
        { ...params },
        {
          ...this.axiosConfigForV1Api(),
          cancelToken: cancelToken.token,
        }
      );

      return res;
    } catch (error) {
      console.error(error);
    }
  }

  async requestCameraSupport(payload: CameraSupportRequest): Promise<number | undefined> {
    try {
      const res = await axios.post('/cameraSupportRequests', payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getApplicationLinks(params: ApplicationLinkParams): Promise<ApiPaginatedApplicationLinksResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get('/accounts/self/applicationLinks', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getSCIMSettings(): Promise<SCIMSettings | undefined> {
    try {
      const res = await axios.get('/accounts/self/scimSettings', this.axiosConfig());

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateSCIMSettings(payload: SCIMSettingsUpdateParams): Promise<AxiosResponse | ApiErrorResponse | undefined> {
    const res = await axios.patch(`/accounts/self/scimSettings`, payload, this.axiosConfig());

    return res;
  }

  async getIdPGroups(params: IdPGroupsParams): Promise<ApiPaginatedIdPGroupResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res: AxiosResponse<ApiPaginatedIdPGroupResponse> = await axios.get('/idPGroups', config);

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getIdPGroup(id: string, params?: IdPGroupParams): Promise<ApiIdPGroupResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res: AxiosResponse<ApiIdPGroupResponse> = await axios.get(`/idPGroups/${id}`, config);

    return res.data;
  }

  async getIdPGroupAssignments(
    params: IdPGroupAssignmentsParams
  ): Promise<ApiPaginatedIdPGroupAssignmentResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res: AxiosResponse<ApiPaginatedIdPGroupAssignmentResponse> = await axios.get(
        '/idPGroupAssignments',
        config
      );

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  // FileGrants APIs

  async createFileGrant(payload: FileGrant): Promise<FileGrantResponse | undefined> {
    try {
      const res = await axios.post('/fileGrants', payload, this.axiosConfig());

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getFileGrants(fileId?: string): Promise<PaginatedFileGrantsResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), {
        params: fileId ? { fileId } : {},
      });

      const res = await axios.get('/fileGrants', config);

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateFileGrant(id: string, payload: FileGrantUpdate): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/fileGrants/${id}`, payload, this.axiosConfig());

      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteFileGrant(id: string): Promise<number | undefined> {
    try {
      const res = await axios.delete(`/fileGrants/${id}`, this.axiosConfig());

      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async createIdPGroupAssignments(
    payload: ApiIdPGroupAssignmentsBulkCreateRequest
  ): Promise<ApiIdPGroupAssignmentsBulkResponse> {
    const res = await axios.post<ApiIdPGroupAssignmentsBulkResponse>(
      `/idPGroupAssignments:bulkCreate`,
      payload,
      this.axiosConfig()
    );

    return res.data;
  }

  async deleteIdPGroupAssignments(
    payload: ApiIdPGroupAssignmentsBulkDeleteRequest
  ): Promise<ApiIdPGroupAssignmentsBulkResponse> {
    const res = await axios.post<ApiIdPGroupAssignmentsBulkResponse>(
      `/idPGroupAssignments:bulkDelete`,
      payload,
      this.axiosConfig()
    );

    return res.data;
  }

  async analyseEevaQueries(payload: EevaQueryPayload): Promise<EevaQueryResponse | undefined> {
    try {
      const res = await axios.post<EevaQueryResponse>('/eevaQueries', payload, this.axiosConfig());

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getIoDevicePortList(
    deviceId: string,
    params: GetDevicePortsParams
  ): Promise<PaginatedDevicesIOResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/devices/${deviceId}/io/ports`, config);

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getIoDevicePort(
    deviceId: string,
    portId: string,
    params: GetDevicePortParams
  ): Promise<ApiDeviceIo | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/devices/${deviceId}/io/ports/${portId}`, config);

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getRecordingActionCameras(
    deviceId: string,
    portId: string,
    params: GetRecordingActionsDevices
  ): Promise<PaginatedPortRecordingActionResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/devices/${deviceId}/io/ports/${portId}/recordingActions`, config);

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getRecordingActionCamera(
    deviceId: string,
    portId: string,
    cameraId: string
  ): Promise<PortRecordingActionGet | undefined> {
    try {
      const res = await axios.get(
        `/devices/${deviceId}/io/ports/${portId}/recordingActions/${cameraId}`,
        this.axiosConfig()
      );

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updatePortConfiguration(
    deviceId: string,
    portId: string,
    payload: ApiDeviceIoPatch
  ): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/devices/${deviceId}/io/ports/${portId}`, payload, this.axiosConfig());

      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async updateRecordingActionCamera(
    deviceId: string,
    portId: string,
    cameraId: string,
    payload: PortRecordingActionPatch
  ): Promise<number | undefined> {
    try {
      const res = await axios.patch(
        `/devices/${deviceId}/io/ports/${portId}/recordingActions/${cameraId}`,
        payload,
        this.axiosConfig()
      );

      return res.status;
    } catch (error) {
      console.log(error);
    }
  }
}

export default new ApiList();
